export const convertStringToNumber = (value: string): number | string => {
  const number = Number(value);

  if (!Number.isNaN(number)) {
    return number;
  }

  return value;
};
